import { UserManager } from "oidc-client";
import { IMLPSCOPES } from "../constants/scopes";
import URLS from '../constants/urls';
import { getEnvironmentFromUrl } from "./network";


var userManager;
var hasbeeninitialized = false;

export const initializeUserManager = () =>
{
    let environment = getEnvironmentFromUrl(window.location.toString(), window.location.search);
    const defaultSettings ={
        response_type: 'code',
        loadUserInfo: false,
        authority: URLS[environment].authEdge,
        client_id: 'WebGLClientPKCE',
        redirect_uri: URLS[environment].product,
        scope: IMLPSCOPES,
        clockSkew: 11100, // in seconds (3h 5m). Default is 300s (5m). Token validation should account for client time or timezone being off +/- a few.
        accessTokenExpiringNotificationTime: 300, // 5 mins
    };

    userManager = new UserManager(defaultSettings);
    hasbeeninitialized = true;
}

export const signinRedirect = () =>
{
    return userManager.signinRedirect();
}

export const signinRedirectCallback = () =>
{
    return userManager.signinRedirectCallback();
}

export const getUser = () =>
{
    return userManager.getUser();
}

export const removeUser = () =>
{
    return userManager.removeUser();
}

export const signout = () =>
{
    return userManager.signoutRedirect();
}


// WEBPACK FOOTER //
// ./src/services/oidc.js